import { render, staticRenderFns } from "./goodListScroll2.vue?vue&type=template&id=2239a311&scoped=true"
import script from "./goodListScroll2.vue?vue&type=script&lang=js"
export * from "./goodListScroll2.vue?vue&type=script&lang=js"
import style0 from "./goodListScroll2.vue?vue&type=style&index=0&id=2239a311&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2239a311",
  null
  
)

export default component.exports